import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Flex,
  Form,
  Radio,
  Select,
  Typography,
} from "antd";
import FormActions from "../../../organisms/FormActions";
import {
  useGroupData,
  useInstanceKYCStore,
} from "../../../../stores/InstanceKYCStore";
import { useEffect } from "react";
import {
  useFetchLoyaltyTier,
  useLoyaltyTierStore,
} from "../../../../stores/LoyaltyTierStore";

const Targeting = ({ form, formData, setFormData, setCurrentStep }) => {
  const fetchGroupData = useGroupData();
  const { groupsData } = useInstanceKYCStore();
  const tierData = useLoyaltyTierStore((state) => state.loyaltyTierData);
  const getLoyaltyTier = useFetchLoyaltyTier();

  useEffect(() => {
    fetchGroupData();
    getLoyaltyTier();
  }, []);

  const groupOptions = groupsData?.groupData?.map((item) => ({
    label: item.groupName,
    value: item.groupId,
  }));

  const tierOptions = tierData?.docs?.map((item) => ({
    label: item.tierName,
    value: item.id,
  }));

  const group = [
    {
      label: "New signups - upto 3 days from date of signup",
      value: 1,
    },
    {
      label: "Users who have used 3 coupons",
      value: 2,
    },
  ];

  const handleNextStep = () => {
    form.validateFields().then((values) => {
      setCurrentStep((prev) => prev + 1);
    });
  };
  return (
    <Flex
      vertical
      gap={22}
      className="bg-color-white rounded shadow px-7 pt-6 pb-7 mb-[80px]"
    >
      <Flex justify="space-between" vertical={false}>
        <Flex vertical>
          <Typography.Title level={5}>Step 2</Typography.Title>
          <Typography.Title level={4} style={{ marginTop: "0" }}>
            Targeting
          </Typography.Title>
        </Flex>
        <Flex gap={20}>
          <Button
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Flex>
      </Flex>
      {/* <Divider className="m-0" /> */}
      <Flex
        vertical
        style={{
          border: "1px solid #E4E6EF",
          borderRadius: "12px",
        }}
      >
        <Typography.Text
          style={{
            marginTop: "0",
            fontSize: "14px",
            fontWeight: "500",
            padding: "24px",
          }}
        >
          User Group Information
        </Typography.Text>
        <Divider style={{ margin: "0" }} />
        <Form form={form} layout="vertical" style={{ padding: "24px" }}>
          <Form.Item
            label="Send notifications to"
            name="groupType"
            rules={[
              {
                required: true,
              },
            ]}
            initialValue={0}
          >
            <Radio.Group
              className="flex-wrap"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  groupType: e.target.value,
                }))
              }
              value={formData.groupType}
            >
              <Radio value={0}>All User Groups</Radio>
              <Radio value={1}>Custom Value</Radio>
            </Radio.Group>
          </Form.Item>

          {form.getFieldValue("groupType") == 1 && (
            <Col span={12}>
              <Form.Item
                label="Select user groups"
                name="groupIds"
                rules={[
                  {
                    required: true,
                    message: "User group is required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  onChange={(value) => {
                    setFormData((prev) => ({
                      ...prev,
                      groupIds: value,
                    }));
                  }}
                  value={formData.groupIds}
                  mode="multiple"
                  allowClear
                  options={groupOptions}
                />
                {/* <Option value={1}>group1</Option>
                  <Option value={2}>group2</Option> */}
                {/* </Select> */}
              </Form.Item>
            </Col>
          )}
        </Form>
      </Flex>

      <Flex
        vertical
        style={{
          border: "1px solid #E4E6EF",
          borderRadius: "12px",
        }}
      >
        <Typography.Text
          style={{
            marginTop: "0",
            fontSize: "14px",
            fontWeight: "500",
            padding: "24px",
          }}
        >
          Tier Information
        </Typography.Text>
        <Divider style={{ margin: "0" }} />
        <Form form={form} layout="vertical" style={{ padding: "24px" }}>
          <Form.Item
            label="Send notifications to"
            name="tierType"
            rules={[
              {
                required: true,
              },
            ]}
            initialValue={0}
          >
            <Radio.Group
              className="flex-wrap"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  tierType: e.target.value,
                }))
              }
              value={formData.tierType}
            >
              <Radio value={0}>All Tiers</Radio>
              <Radio value={1}>Custom Value</Radio>
            </Radio.Group>
          </Form.Item>

          {form.getFieldValue("tierType") == 1 && (
            <Col span={12}>
              <Form.Item
                label="Select tiers"
                name="tierIds"
                rules={[
                  {
                    required: true,
                    message: "Tiers is required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  onChange={(value) => {
                    setFormData((prev) => ({
                      ...prev,
                      tierIds: value,
                    }));
                  }}
                  value={formData.tierIds}
                  mode="multiple"
                  allowClear
                  options={tierOptions}
                />
                {/* <Select.Option value={1}>group1</Select.Option>
                  <Select.Option value={2}>group2</Select.Option>
                </Select> */}
              </Form.Item>
            </Col>
          )}
        </Form>
      </Flex>

      <FormActions
        actionButtons={[
          {
            id: 1,
            buttonType: "primary",
            buttonHTMLType: "submit",
            buttonText: "Next Step",
            handleButton: handleNextStep,
          },
        ]}
      />
    </Flex>
  );
};

export default Targeting;
